import { render } from "./BorrowerView.vue?vue&type=template&id=beab3c30"
import script from "./BorrowerView.vue?vue&type=script&lang=js"
export * from "./BorrowerView.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__